import { domain } from "../auth/domain"; // Assuming you have this for your API domain
import swal from "sweetalert2";

const brand = "#800b33";

// Helper to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: "An unknown error occurred." }));
    const errorMessage = errorData.detail || Object.values(errorData).join("\n");
    throw new Error(errorMessage);
  }
  // For 204 No Content, return a success indicator
  if (response.status === 204) {
    return { success: true };
  }
  return response.json();
};

// Helper to get the auth token
const getAuthHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    Authorization: `JWT ${accessToken}`,
  };
};

/**
 * Fetches all emergency contribution events for the user's group.
 */
export const fetchEmergencyEvents = async () => {
  const response = await fetch(`${domain}contributions/emergency/`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};



/**
 * Fetches emergency invoices for a specific member.
 * @param {number} memberId - The ID of the member.
 */
export const fetchMemberEmergencyInvoices = async (memberId) => {
  const response = await fetch(`${domain}contributions/emergency-invoices/`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};





/**
 * Initiates a new emergency contribution (Chairperson action).
 * @param {object} payload - The form data { title, type, deductionPerMember }.
 */
export const createEmergencyEvent = async (payload) => {
  const body = {
    event_name: payload.title,
    event_type: payload.type.toUpperCase(), // Match backend choices like 'BEREAVEMENT'
    amount_per_member: payload.deductionPerMember,
    description: `Emergency contribution for ${payload.title}`,
  };
  const response = await fetch(`${domain}contributions/emergency/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return handleResponse(response);
};

/**
 * Approves or rejects an emergency contribution event.
 * @param {number} eventId - The ID of the event.
 * @param {boolean} isApprove - True to approve, false to reject.
 * @param {string} [reason] - The reason for rejection (optional).
 */
export const reviewEmergencyEvent = async (eventId, isApprove, reason = "") => {
  const payload = isApprove ? {} : { rejection_reason: reason };
  const response = await fetch(`${domain}contributions/emergency/${eventId}/approve/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};
